import type {
    ConcreteIdea,
    IdeaRecord,
    NewIdea,
    IdeaPut,
} from '@thinkalpha/platform-ws-client/contracts/ideas/index.js';
import type { ResourceQuery, ResourceQueryResponseWithMeta } from '@thinkalpha/ui-types/contracts/resource-query';
import type { AxiosResponse } from 'axios';
import Dataloader from 'dataloader';
import { api } from 'src/api';
import { processQuery } from 'src/lib/paging';

export function createIdeaWithMappedImports(idea: NewIdea): Promise<ConcreteIdea> {
    return api.post<ConcreteIdea>('/ideas?$expand=imports', idea).then((x) => x.data);
}

export function putIdea(id: string, ideaSubset: IdeaPut): Promise<ConcreteIdea> {
    return api.put<ConcreteIdea>(`/ideas/${id}`, ideaSubset).then((x) => x.data);
}

export function updateIdea(idea: ConcreteIdea): Promise<ConcreteIdea> {
    return api.put<ConcreteIdea>(`/ideas/${idea.id}`, idea).then((x) => x.data);
}

export function createIdea(idea: NewIdea): Promise<ConcreteIdea> {
    return api.post<ConcreteIdea>('/ideas', idea).then((x) => x.data);
}

export function deleteIdeaById(id: string): Promise<AxiosResponse> {
    return api.delete(`/ideas/${id}`);
}

export const ideaRecordLoader = new Dataloader<string, IdeaRecord | null>(
    async (ids): Promise<(IdeaRecord | null)[]> => {
        const result = (
            await api.get<IdeaRecord[]>('/ideas/records', {
                params: { ids },
            })
        ).data;

        const map = new Map(result.map((x) => [x.id, x] as const));

        return ids.map((id) => map.get(id) ?? null);
    },
    { cache: false },
);

export const ideaLoader = new Dataloader<string, ConcreteIdea | null>(
    async (ids): Promise<(ConcreteIdea | null)[]> => {
        const result = (await api.get<ConcreteIdea[]>(`/ideas`, { params: { ids } })).data;

        const map = new Map(result.map((x) => [x.id, x] as const));

        return ids.map((id) => map.get(id) ?? null);
    },
    { cache: false },
);

export const getIdeaRecordsSearch = async (
    query: ResourceQuery,
): Promise<ResourceQueryResponseWithMeta<IdeaRecord>> => {
    return (await api.get(`/ideas/query${processQuery(query)}`)).data;
};

export const getIdeaRecordsCount = async (): Promise<ResourceQueryResponseWithMeta<IdeaRecord>> => {
    return (await api.get(`/ideas/query?$select=&$count=true`)).data;
};
